import { CharacteristicsResponse } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/ResponseDto';

import { Flash } from '@r1-frontend/ui-react/components/svg/main';
import { TRouterCardCharacteristicsProps } from '@r1-frontend/ui-react/organisms/Card/Router/Router';
import { truncate } from '@r1-frontend/shared/helpers/truncate';

const prepareCharacteristic = (characteristic: CharacteristicsResponse): TRouterCardCharacteristicsProps => {
    return {
        title: truncate(characteristic.title, 20),
        value: truncate(characteristic.value, 10),
        Icon: Flash,
    };
};

export default prepareCharacteristic;
